import { render, staticRenderFns } from "./MemoInfo.vue?vue&type=template&id=8c6be20e&scoped=true"
import script from "./MemoInfo.vue?vue&type=script&lang=js"
export * from "./MemoInfo.vue?vue&type=script&lang=js"
import style0 from "./MemoInfo.vue?vue&type=style&index=0&id=8c6be20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6be20e",
  null
  
)

export default component.exports